export default "__VITE_ASSET__BACerbHX__"